var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        "div",
        { staticClass: "eu-pa_6 eu-align_center" },
        [_c("emd-loader", { attrs: { type: "_invert" } })],
        1
      )
    : _c(
        "div",
        { staticClass: "el-grid-list _auto-fill _size_large eu-mt_4" },
        [
          _vm.permissions.length
            ? _vm._l(_vm.permissions, function (permission) {
                return _c("permission-card", {
                  key: permission.id,
                  attrs: { permission: permission },
                  on: { openModalChangeDefault: _vm.openModalChangeDefault },
                })
              })
            : [_c("permission-card", { attrs: { isEmpty: "" } })],
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }